
import { NoData } from 'components/NoData';
import { Pagination } from 'components/Pagination/Pagination';
import { StatusPill } from 'components/ui/StatusPill/StatusPill';
import { Td } from 'components/Td/Td';
import { PageFooter, Table, Th, Tr } from 'styling/GlobalStyles';
import { IGetAllCompanyAttendanceReportsSingleResponse } from 'types/api/attendanceApi.interface';
import { IPaginatedResponse } from 'types/api/general.interface';
import { formatDateForDisplay, formatTimeAMPM, handlePagination } from 'utils/helpers';

export const CompanyReports = ({ reports, params, setParams }: { reports: IPaginatedResponse<IGetAllCompanyAttendanceReportsSingleResponse>, params: any, setParams: React.Dispatch<React.SetStateAction<any>> }) => {
    return <>{reports?.data.length ? <Table>
        <Th>
            <Td w='20%' >Date From</Td>
            <Td w='20%' >Date To</Td>
            <Td w='60%' >Aproval Status</Td>
        </Th>
        {reports?.data.map((r, i) => <Tr key={i}>
            <Td w='20%' >{formatDateForDisplay(r.dateFrom)} {formatTimeAMPM(r.dateFrom)}</Td>
            <Td w='20%' >{formatDateForDisplay(r.dateTo)} {formatTimeAMPM(r.dateTo)}</Td>
            <Td w='60%' ><StatusPill status={r.approvalStatus === 2 ? 'success' : r.approvalStatus === 3 ? 'danger' : 'warning'}>{reportStatuses[r.approvalStatus - 1]}</StatusPill></Td>
        </Tr>)}
    </Table> : <NoData />}
        <PageFooter>
            <Pagination
                setPage={(page) => handlePagination(page, setParams, 30)}
                pageCount={Math.ceil(reports.totalPages)}
                forcePage={(params.page ? params.page : 1) - 1}
            />
        </PageFooter>
    </>
}

const reportStatuses = ['Pending', 'Approved', 'Rejected']